import { render, staticRenderFns } from "./api-file-form.vue?vue&type=template&id=0c21229d&scoped=true&"
import script from "./api-file-form.vue?vue&type=script&lang=ts&"
export * from "./api-file-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c21229d",
  null
  
)

export default component.exports